import React, { useState, useEffect } from 'react';
import { Users, UserCircle } from 'lucide-react';
import { getSeanceParticipants } from '../services/api';
import { Link } from 'react-router-dom';

function ParticipantsList({ clubId, seanceIndex, date, seance, compact = false }) {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showList, setShowList] = useState(false);

  const fetchParticipants = async () => {
    setLoading(true);
    try {
      const data = await getSeanceParticipants(clubId, seanceIndex.toString(), date);
      setParticipants(data);
    } catch (error) {
      console.error('Erreur chargement participants:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (showList) {
      fetchParticipants();
    }
  }, [showList]);

  // Si compact=true, ne rien afficher
  if (compact) {
    return null;
  }

  return (
    <div className="mt-2">
      <button
        onClick={() => setShowList(!showList)}
        className="flex items-center space-x-2 text-sm text-indigo-600 hover:text-indigo-800 font-semibold"
      >
        <Users size={16} />
        <span>
          {participants.length > 0 ? `${participants.length} participant${participants.length > 1 ? 's' : ''}` : 'Voir les participants'}
        </span>
      </button>

      {showList && (
        <div className="mt-3 bg-gray-50 rounded-lg p-3">
          {loading ? (
            <p className="text-sm text-gray-600">Chargement...</p>
          ) : participants.length > 0 ? (
            <div className="space-y-2">
              {participants.map(participant => (
                <Link
                  key={participant._id}
                  to={`/user/${participant._id}`}
                  className="flex items-center space-x-3 p-2 hover:bg-white rounded-lg transition"
                >
                  {participant.photoProfil ? (
                    <img
                      src={participant.photoProfil}
                      alt={`${participant.prenom} ${participant.nom}`}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-indigo-600 flex items-center justify-center">
                      <UserCircle size={24} className="text-white" />
                    </div>
                  )}
                  <div className="flex-1">
                    <p className="font-semibold text-gray-800">
                      {participant.prenom} {participant.nom}
                    </p>
                    <p className="text-xs text-gray-600">
                      {participant.ville} • {participant.niveauCourse}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-600">Aucun participant pour le moment. Soyez le premier !</p>
          )}
        </div>
      )}
    </div>
  );
}

export default ParticipantsList;